import './Home.css';
function Home() {
    return <h1 className="home">Welcome to the Home of Fun!, Please seat back and lets make your day beautiful with lots of laughter from different varieties of jokes.
      We know the world is awesome!, but can sometimes be filled with lots of challenges and petty problems, Therefore we are here to make your day beautiful and make you feel life from simple laughter. </h1> 
  
  }
  export default Home;